import { IWishListState } from "./types";
import ActionTypes from "../../../constants/ActionTypes";

const initialState: IWishListState = {
  productIds: [],
  products: []
};

const wishListReducer = (
  state = initialState,
  action: any,
): any => {
  switch (action.type) {
  case ActionTypes.WISH_LIST.ADD_PRODUCT_ON_WISH_LIST:
    return {
      ...state,
      productIds: [...state.productIds, action.payload]
    };
  case ActionTypes.WISH_LIST.REMOVE_PRODUCT_FROM_WISH_LIST:
    return {
      ...state,
      productIds: state.productIds.filter((id: number) => id !== action.payload)
    };
  case ActionTypes.WISH_LIST.SET_PRODUCTS:
    return {
      ...state,
      products: action.payload
    };
  case ActionTypes.WISH_LIST.SET_PRODUCT_IDS:
    return {
      ...state,
      productIds: action.payload
    };
  }
  return state;
};

export default wishListReducer;
